import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

//utils
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";
import {
  separateRoles,
  cleanUsers,
  uniqueUsers,
  buildInvestigatorProject,
} from "../../../../utils/auxiliar/manageProject";

//middleware
import moment from "moment";
import produce from "immer";
import Swal from "sweetalert2";
import Axios from "axios";
import { validate } from "./validations";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
registerLocale("es", es);

export const ManageProject = () => {
  let { isAdmin, userRoleId, staffId } = useSelector(({ user }) => user);
  const { PROJECTS, INVESTIGATORS, investigatorPROJECT, RESEARCHLINES, GROUPS  } = paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const [isCreate, setIsCreate] = useState(false);

  //userForm
  const [tituloEs, setTituloEs] = useState("");
  const [tituloEn, setTituloEn] = useState("");
  const [codigo, setCodigo] = useState('')
  const [resumenEs, setResumenEs] = useState("");
  const [resumenEn, setResumenEn] = useState("");
  const [entidadFinanciadora, setEntidadFinanciadora] = useState("");
  const [mostrarWeb, setMostrarWeb] = useState("");
  const [estado, setEstado] = useState("");
  const [fechaInicio, setFechaInicio] = useState(new Date());
   const [fechaFin, setFechaFin] = useState(new Date());
  const [ips, setIps] = useState([]);
  const [chosenIps, setChosenIps] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [chosenParticipants, setChosenParticipants] = useState([]);
  const [researchLines, setResearchLines] = useState([]);
  const [chosenResearchLines, setChosenResearchLines] = useState([]);
     const [investigationGroups, setInvestigationGroups] = useState([]);
     const [chosenInvestigationGroupId, setChosenInvestigationGroupId] =
       useState("");

  // const [logo, setLogo] = useState();
  const [logoEntidad1, setLogoEntidad1] = useState();
  const [logoEntidad2, setLogoEntidad2] = useState();
  const [logoEntidad3, setLogoEntidad3] = useState();
  const [message, setMessage] = useState("");

  const [selected, setSelected] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();
  const [datosCargados, setDatosCargados] = useState(false);

  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {
      let investigators = await getAll(INVESTIGATORS, source);
      let researchLines = await getAll(RESEARCHLINES, source);
      let investigationGroups = await getAll(GROUPS, source)
      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);
        setTimeout(() => filterAdmins(investigators), 250);
        setResearchLines(researchLines);
        setInvestigationGroups(investigationGroups)
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterAdmins = (investigators) => {
    let newinvestigators = investigators.filter(
      (u) =>
        u.email !== "admin@admin.com" &&
        u.email !== "sombradoble@sombradoble.es"
    );
    setIps(newinvestigators);
    setParticipants(newinvestigators);
  };

  const loadEditData = async () => {
    try {
      let response = await getById(PROJECTS, id, source);
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (p) => {
    let allResearchLines = await getAll(RESEARCHLINES, source);
    let allInvestigationGroups = await getAll(GROUPS, source)
    const startDateWithOffset = new Date(p.fechaInicio);
    const startDateNoOffset = new Date(
      startDateWithOffset.getTime() -
        startDateWithOffset.getTimezoneOffset() * -60000
    );
    const endDateWithOffset = new Date(p.fechaFin);
    const endDateNoOffset = new Date(
      endDateWithOffset.getTime() -
        endDateWithOffset.getTimezoneOffset() * -60000
    );
    setTituloEn(p.tituloEn);
    setTituloEs(p.tituloEs);
    setCodigo(p.codigo)
    setResumenEn(p.resumenEn);
    setResumenEs(p.resumenEs);
    setEntidadFinanciadora(p.entidadFinanciadora);
    setMostrarWeb(p.mostrarWeb);
    setEstado(p.estado);
    setFechaInicio(startDateNoOffset);
    setFechaFin(endDateWithOffset);
    // setLogo(p.logo);
    setLogoEntidad1(p.logoEntidad1);
    setLogoEntidad2(p.logoEntidad2);
    setLogoEntidad3(p.logoEntidad3);
    setResearchLines(allResearchLines);
    setChosenResearchLines(p.researchLines);
        setChosenInvestigationGroupId(p.investigationGroup?.id);
        setInvestigationGroups(allInvestigationGroups);
    let investigators = await getAll(INVESTIGATORS, source);
    if (isMounted.current) {
      setIpsDisplay(p, investigators);
      setParticipantsDisplay(p, investigators);
      setAllowedEdit(true);
      setDatosCargados(true);
    }
  };

  const setIpsDisplay = async ({ staffProjects }, investigators) => {
    const { ips, participants } = separateRoles(staffProjects);
    setChosenIps(ips);

    //get unassigned investigators by comparing with chosenIps
    let rawIps = uniqueUsers(investigators, ips);
    let unassignedIps = uniqueUsers(rawIps, participants);
    setIps(cleanUsers(unassignedIps));
  };

  const setParticipantsDisplay = async ({ staffProjects }, investigators) => {
    const { ips, participants } = separateRoles(staffProjects);
    setChosenParticipants(participants);

    //get unassigned investigators by comparing with participants
    let rawInvs = uniqueUsers(investigators, participants);
    let unassignedInvs = uniqueUsers(rawInvs, ips);

    setParticipants(cleanUsers(unassignedInvs));
  };

  // HANDLE INVESTIGATORS
  const addInvestigator = (ip, investigator) => {
    ip = JSON.parse(ip);

    investigator === "IP"
      ? //add chosenIp
        setChosenIps((state) =>
          produce(state, (drafState) => {
            drafState.push(ip);
          })
        )
      : //add chosenParticipant
        setChosenParticipants((state) =>
          produce(state, (drafState) => {
            drafState.push(ip);
          })
        );

    //remove ip from list
    setIps((state) =>
      produce(state, (drafState) => drafState.filter(({ id }) => id !== ip.id))
    );

    //remove participant from list
    setParticipants((state) =>
      produce(state, (drafState) => drafState.filter(({ id }) => id !== ip.id))
    );
  };

  const removeInvestigator = (ip, investigator) => {
    if (!allowedEdit) return;
    investigator === "IP"
      ? // remove chosenIp
        setChosenIps((state) =>
          produce(state, (drafState) =>
            drafState.filter(({ id }) => id !== ip.id)
          )
        )
      : // remove chosenParticipan
        setChosenParticipants((state) =>
          produce(state, (drafState) =>
            drafState.filter(({ id }) => id !== ip.id)
          )
        );

    // add ip to list
    setIps((state) =>
      produce(state, (drafState) => {
        drafState.push(ip);
      })
    );

    // add participant to list
    setParticipants((state) =>
      produce(state, (drafState) => {
        drafState.push(ip);
      })
    );
  };

  const addItem = (item, type) => {
    item = JSON.parse(item);
    if (type === "researchLines") {
      setChosenResearchLines((state) =>
        produce(state, (draftState) => {
          draftState.push(item);
        })
      );
      setResearchLines((state) =>
        produce(state, (draftState) =>
          draftState.filter(({ id }) => id !== item.id)
        )
      );
    }
  };

  const removeItem = (item, type) => {
    if (!allowedEdit) return;
    if (type === "researchLines") {
      setChosenResearchLines((state) =>
        produce(state, (draftState) =>
          draftState.filter(({ id }) => id !== item.id)
        )
      );
      setResearchLines((state) =>
        produce(state, (draftState) => {
          draftState.push(item);
        })
      );
    }
  };

  const handleSubmit = () => {
    const project = build();
    const notValid = validate(project);
    if (notValid) {
      setMessage(notValid);
      setTimeout(() => setMessage(""), 4000);
      return;
    }
    let question = isCreate ? "crear un" : "editar este";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} proyecto?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => isConfirmed && handleConfirmation(project));
  };

  const handleConfirmation = (project) => {
    let createOrUpdate = isCreate
      ? create(PROJECTS, project, source)
      : update(PROJECTS, id, project, source);
    createOrUpdate
      .then(async ({ id: projectId }) => {
        const investigatorProjects = buildInvestigatorProject(
          chosenParticipants,
          chosenIps,
          projectId
        );
        await create(
          `${investigatorPROJECT}/${projectId}`,
          investigatorProjects,
          source
        );

        let createOrUpdateText = isCreate ? "creado" : "editado";
        Swal.fire({
          icon: "success",
          text: `Proyecto ${createOrUpdateText} correctamente.`,
        });
        // if (typeof logo !== "string") {
        //   const formData = new FormData();
        //   formData.append("image", logo);
        //   await saveFile(PROJECTS, projectId, "logo", formData, source);
        // }
        if (typeof logoEntidad1 !== "string") {
          const formData = new FormData();
          formData.append("image", logoEntidad1);
          await saveFile(PROJECTS, projectId, "logoEntidad1", formData, source);
        }
        if (typeof logoEntidad2 !== "string") {
          const formData = new FormData();
          formData.append("image", logoEntidad2);
          await saveFile(PROJECTS, projectId, "logoEntidad2", formData, source);
        }
        if (typeof logoEntidad3 !== "string") {
          const formData = new FormData();
          formData.append("image", logoEntidad3);
          await saveFile(PROJECTS, projectId, "logoEntidad3", formData, source);
        }
        history.push(`${ROUTES.Projects.all}/${projectId}`);
        isMounted.current && setIsCreate(false);
      })
      .catch(() => Swal.fire({ icon: "error", text: SwalError }));
  };

  const build = () => {
    const project = {
      tituloEs,
      tituloEn,
      codigo,
      fechaInicio: moment(fechaInicio).format("YYYY-MM-DD"),
      fechaFin: moment(fechaFin).format("YYYY-MM-DD"),
      resumenEs,
      resumenEn,
      entidadFinanciadora,
      mostrarWeb,
      estado,
      researchLineIds: chosenResearchLines.map(
        (researchLine) => researchLine.id
      ),
      investigationGroupId: +chosenInvestigationGroupId,
      // programId: +chosenProgramId,
    };

    return project;
  };

const editDeleteButtons = () => {
  if (isCreate) {
    return (
      <button className="baseBtn" onClick={handleSubmit}>
        Crear Proyecto
      </button>
    );
  }

  const isLoggedUserIP = chosenIps.some((ip) => ip.id === staffId);

  if (!isLoggedUserIP && !isAdmin) return null;

  return (
    <>
      <button className="baseBtn" onClick={handleSubmit}>
        Guardar cambios
      </button>
      <button
        className="smallBtn btn-danger ml-1"
        onClick={() => deleteIt(PROJECTS, id, ROUTES.Projects.all, source)}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    </>
  );
};


  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 3 || userRoleId === 2) && (
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Proyecto </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            {/* <div className="col-6 d-flex justify-content-center">
              <FileUploader handleFile={setLogo} image={logo} />
            </div> */}
            <div className="col-6  d-flex flex-column  ">
              <small>Título en español (acrónimo)*</small>
              <input
                type="text"
                className="form-control"
                placeholder="*Título español"
                value={tituloEs}
                onChange={({ target: { value } }) => setTituloEs(value)}
              />
              <small>Título en inglés (acrónimo)*</small>
              <input
                type="text"
                className="form-control"
                placeholder="Título inglés"
                maxLength="500"
                value={tituloEn}
                onChange={({ target: { value } }) => setTituloEn(value)}
              />
              <small>Código</small>
              <input
                type="text"
                className="form-control"
                placeholder="Código"
                maxLength="500"
                value={codigo}
                onChange={({ target: { value } }) => setCodigo(value)}
              />
            </div>
          </div>

          <div className="form-row mt-2"> </div>

          <div className="form-row mt-4">
            <div className="col">
              <span>Fecha de inicio</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Inicio"
                selected={fechaInicio}
                onChange={(date) => setFechaInicio(date)}
                dateFormat="dd MMMM, yyyy"
                locale="es"
              />
            </div>
            <div className="col">
              <span>Fecha de fin</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Fin"
                selected={fechaFin}
                onChange={(date) => setFechaFin(date)}
                dateFormat="dd MMMM, yyyy"
                locale="es"
              />
            </div>
          </div>
          <div className="form-row mt-4">
            {" "}
            <div className="col-6">
              <small>Seleccionar departamentos</small>
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addItem(value, "researchLines")
                }
              >
                <option value={""}>Seleccionar departamentos</option>
                {researchLines?.map((r) => (
                  <option key={r.id} value={JSON.stringify(r)}>
                    {r.tituloEs}
                  </option>
                ))}
              </select>
              {chosenResearchLines?.map((r) => (
                <span
                  key={r.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() => removeItem(r, "researchLines")}
                >
                  {r.tituloEs} X
                </span>
              ))}
            </div>
            <div className="col-6">
              <small>Seleccionar Grupo de investigación</small>
              <select
                className="form-control input"
                value={chosenInvestigationGroupId}
                onChange={({ target: { value } }) => {
                  setChosenInvestigationGroupId(value);
                }}
              >
                <option>Grupo</option>
                {investigationGroups?.map(({ id, nameEs }) => (
                  <option key={id} value={id}>
                    {nameEs}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addInvestigator(value, "IP")
                }
              >
                <option value={""}>Investigadores principales</option>
                {ips?.map((i) => (
                  <option key={i.id} value={JSON.stringify(i)}>
                    {`${i.apellidos} , ${i.nombre}`}
                  </option>
                ))}
              </select>
              {chosenIps?.map((ip) => (
                <span
                  key={ip.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3  "
                  onClick={() => removeInvestigator(ip, "IP")}
                >
                  {`${ip.nombre} ${ip.apellidos}`} X
                </span>
              ))}
            </div>
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addInvestigator(value, "PARTICIPANT")
                }
              >
                <option value={""}>Investigadores participantes</option>
                {participants?.map((i) => (
                  <option key={i.id} value={JSON.stringify(i)}>
                    {`${i.apellidos} , ${i.nombre}`}
                  </option>
                ))}
              </select>
              {chosenParticipants?.map((participant) => (
                <span
                  key={participant.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3  "
                  onClick={() => removeInvestigator(participant, "PARTICIPANT")}
                >
                  {`${participant.nombre} ${participant.apellidos} `}X
                </span>
              ))}
            </div>
          </div>

          <div className="form-row mt-4">
            {" "}
            <div className="col-6">
              <small>¿Mantener en la web una vez finalizado?</small>
              <select
                className="form-control input"
                value={mostrarWeb}
                onChange={({ target: { value } }) => {
                  setMostrarWeb(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="Si">Sí</option>
                <option value="No">No</option>
              </select>
            </div>
            {/* <div className="col-6">
              <small>Estado</small>
              <select
                className="form-control input"
                value={estado}
                onChange={({ target: { value } }) => {
                  setEstado(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="En_curso">En Curso</option>
                <option value="Cerrado">Cerrado </option>
              </select>
            </div> */}
          </div>

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en español</small>
                  <CKEditor
                    initData={resumenEs}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenEs(editor.getData())}
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en inglés</small>
                  <CKEditor
                    initData={resumenEn}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenEn(editor.getData())}
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Texto en español</small>
                    <CKEditor
                      initData={resumenEs}
                      config={editorConfig}
                      onChange={({ editor }) => setResumenEs(editor.getData())}
                      readOnly={!allowedEdit}
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Texto en inglés</small>
                    <CKEditor
                      initData={resumenEn}
                      config={editorConfig}
                      onChange={({ editor }) => setResumenEn(editor.getData())}
                    />
                  </div>
                </div>
              </>
            )
          )}
          <div className="form-row mt-4">
            {" "}
            {isCreate ? (
              <div className="col">
                <small>Entidades financiadoras</small>
                <CKEditor
                  initData={entidadFinanciadora}
                  config={editorConfig}
                  onChange={({ editor }) =>
                    setEntidadFinanciadora(editor.getData())
                  }
                />
              </div>
            ) : (
              datosCargados && (
                <div className="col">
                  <small>Entidades financiadoras</small>
                  <CKEditor
                    initData={entidadFinanciadora}
                    config={editorConfig}
                    onChange={({ editor }) =>
                      setEntidadFinanciadora(editor.getData())
                    }
                  />
                </div>
              )
            )}
          </div>
          <div className="form-row mt-4 mb-4">
            <small>Logos entidades financiadoras</small>

            <div className="col-6 d-flex justify-content-center mt-4">
              <FileUploader handleFile={setLogoEntidad1} image={logoEntidad1} />
              <FileUploader handleFile={setLogoEntidad2} image={logoEntidad2} />
              <FileUploader handleFile={setLogoEntidad3} image={logoEntidad3} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
